import Vue from 'vue'
import Router from 'vue-router'
import NewReportPage from '@/pages/NewReport'
import CoursePage from '@/pages/Course'
// import { constants } from '@/utils/constants'
import UserPage from '@/pages/User'
import GroupPage from '@/pages/Groups'
import LoginPage from '@/pages/Login'
import ErrorPage from '@/pages/Error'
import ChallengePage from '@/pages/Challenges'
import LeapsChallengePage from '@/pages/LeapsChallenges'
import LeapsMeditationPage from '@/pages/LeapsMeditation'
import LeapsActionPage from '@/pages/LeapsAction'
import LeapsCategoryPage from '@/pages/LeapsCategory'
import LeapsEnergyPage from '@/pages/LeapsEnergy'
import LeapsAffirmationPage from '@/pages/LeapsAffirmation'
import LeapsIntentionPage from '@/pages/LeapsIntention'
import ManageContentPage from '@/pages/ManageContent'
import MasterTopicPage from '@/pages/MasterTopic'
import LearningLevelPage from '@/pages/LearningLevel'
import AssessmentPage from '@/pages/Assessment'
import AssessmentJourneyPage from '@/pages/AssessmentJourney'
import UserResponsesPage from '@/pages/UserResponses'
import ChallengeReportPage from '@/pages/ChallengeReport'
import UserProgressPage from '@/pages/UserProgressReport'
import DashboardPage from '@/pages/Dashboard'
import NewDashboard from '@/pages/NewDashboard'
import ProfilePage from '@/pages/Profile'
import MCQReportPage from '@/pages/MCQReport'
import MeetingMentorReportPage from '@/pages/MeetingMentorReport'
import AssessmentSubTypeReport from '@/pages/AssessmentSubTypeReport'
import DeepDivePage from '@/pages/DeepDive'
import ReflectionPage from '@/pages/Reflection'
import SSOConfigurationPage from '@/pages/SSOConfiguration'
import cohortsPage from '@/pages/Cohorts'
import UtilitiesPage from '@/pages/Utilities'
import ForgotPasswordPage from '@/pages/ForgotPassword'
import EmailPage from '@/pages/Email'
import ProgressionEmailPage from '@/pages/ProgressionEmail'
import DashboardEmailPage from '@/pages/DashboardEmail'
import ViewSentEmailPage from '@/pages/ViewSentEmails'
import FileUploaderPage from '@/pages/FileUploader'
import ScreenLoadingPage from '@/pages/ScreenLoading'
import AdminActivityPage from '@/pages/AdminActivity'
import LessonWiseProgress from '@/pages/LessonWiseProgress'
import ElementWiseProgress from '@/pages/ElementWiseProgress'
import ResetPassword from '@/pages/ResetPassword'
import SendGridPage from '@/pages/SendGrid'
import TestPage from '@/pages/TestPage'
import mentoraPage from '@/pages/Mentora365'
import msNotificationPage from '@/pages/MSNotification'
import m365ReportPage from '@/pages/M365Report'
import MomentsReportPage from '@/pages/MomentsReport'
import missionReportPage from '@/pages/MissionReport'
import adaptiveGameReportPage from '@/pages/AdaptiveGameReport'
import vatConsumptionReportPage from '@/pages/VATConsumptionReport'
import milestoneReportPage from '@/pages/MilestoneReport'
import certificateReportPage from '@/pages/CertificateReport'
import learnPerformReportPage from '@/pages/LearnPerformReport'
import tinyMcePage from '@/pages/TinyMce'

Vue.use(Router)

const router = new Router({
  routes: [
    /*
    {
      path: '/',
      name: 'home',
      component: DashboardPage,
      beforeEnter: guardRoute
    }, */
    {
      path: '/',
      name: 'dashboard',
      component: NewDashboard,
      beforeEnter: guardRoute
    },
    {
      path: '/newreport',
      name: 'newreport',
      component: NewReportPage,
      beforeEnter: guardRoute
    },
    {
      path: '/courses',
      name: 'courses',
      component: CoursePage,
      beforeEnter: guardRoute
    },
    {
      path: '/users',
      name: 'users',
      component: UserPage,
      beforeEnter: guardRoute
    },
    {
      path: '/groups',
      name: 'groups',
      component: GroupPage,
      beforeEnter: guardRoute
    },
    {
      path: '/cohorts',
      name: 'cohorts',
      component: cohortsPage,
      beforeEnter: guardRoute
    },
    {
      path: '/utilities',
      name: 'utilities',
      component: UtilitiesPage,
      beforeEnter: guardRoute
    },
    {
      path: '/login',
      name: 'login',
      component: LoginPage
    },
    {
      path: '/challenges',
      name: 'Challenges',
      component: ChallengePage,
      beforeEnter: guardRoute
    },
    {
      path: '/challengelibrary',
      name: 'LeapsChallenges',
      component: LeapsChallengePage,
      beforeEnter: guardRoute
    },
    {
      path: '/meditationlibrary',
      name: 'LeapsMeditation',
      component: LeapsMeditationPage,
      beforeEnter: guardRoute
    },
    {
      path: '/actionlibrary',
      name: 'LeapsAction',
      component: LeapsActionPage,
      beforeEnter: guardRoute
    },
    {
      path: '/categorylibrary',
      name: 'LeapsCategory',
      component: LeapsCategoryPage,
      beforeEnter: guardRoute
    },
    {
      path: '/energylibrary',
      name: 'LeapsEnergy',
      component: LeapsEnergyPage,
      beforeEnter: guardRoute
    },
    {
      path: '/affirmationlibrary',
      name: 'LeapsAffirmation',
      component: LeapsAffirmationPage,
      beforeEnter: guardRoute
    },
    {
      path: '/intentionlibrary',
      name: 'LeapsIntention',
      component: LeapsIntentionPage,
      beforeEnter: guardRoute
    },
    {
      path: '*',
      name: 'Error',
      component: ErrorPage,
      beforeEnter: guardRoute
    },
    {
      path: '/managecontent',
      name: 'ManageContent',
      component: ManageContentPage,
      beforeEnter: guardRoute
    },
    {
      path: '/mastertopic',
      name: 'MasterTopic',
      component: MasterTopicPage,
      beforeEnter: guardRoute
    },
    {
      path: '/learninglevel',
      name: 'LearningLevel',
      component: LearningLevelPage,
      beforeEnter: guardRoute
    },
    {
      path: '/assessment',
      name: 'Assessment',
      component: AssessmentPage,
      beforeEnter: guardRoute
    },
    {
      path: '/assessmentjourney',
      name: 'AssessmentJourney',
      component: AssessmentJourneyPage,
      beforeEnter: guardRoute
    },
    {
      path: '/userresponses',
      name: 'UserResponses',
      component: UserResponsesPage,
      beforeEnter: guardRoute
    },
    {
      path: '/challengereport',
      name: 'ChallengeReport',
      component: ChallengeReportPage,
      beforeEnter: guardRoute
    },
    {
      path: '/userprogress',
      name: 'UserProgress',
      component: UserProgressPage,
      beforeEnter: guardRoute
    },
    {
      path: '/mcqreport',
      name: 'MCQReport',
      component: MCQReportPage,
      beforeEnter: guardRoute
    },
    {
      path: '/meetingmentorreport',
      name: 'MeetingMentorReport',
      component: MeetingMentorReportPage,
      beforeEnter: guardRoute
    },
    {
      path: '/assessmentreport',
      name: 'AssessmentReport',
      component: AssessmentSubTypeReport,
      beforeEnter: guardRoute
    },
    {
      path: '/deepdive',
      name: 'DeepDive',
      component: DeepDivePage,
      beforeEnter: guardRoute
    },
    {
      path: '/reflection',
      name: 'Discussions',
      component: ReflectionPage,
      beforeEnter: guardRoute
    },
    {
      path: '/profile',
      name: 'Profile',
      component: ProfilePage,
      beforeEnter: guardRoute
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: DashboardPage,
      beforeEnter: guardRoute
    },
    {
      path: '/forgotpassword',
      name: 'forgotpassword',
      component: ForgotPasswordPage,
      beforeEnter: guardRoute
    },
    {
      path: '/email',
      name: 'email',
      component: EmailPage,
      beforeEnter: guardRoute
    },
    {
      path: '/progressionemail',
      name: 'progressionemail',
      component: ProgressionEmailPage,
      beforeEnter: guardRoute
    },
    {
      path: '/dashboardemail',
      name: 'DashboardEmail',
      component: DashboardEmailPage,
      beforeEnter: guardRoute
    },
    {
      path: '/viewsentemails',
      name: 'viewsentemails',
      component: ViewSentEmailPage,
      beforeEnter: guardRoute
    },
    {
      path: '/filerepository',
      name: 'fileuploader',
      component: FileUploaderPage,
      beforeEnter: guardRoute
    },
    {
      path: '/screenloading',
      name: 'screenloading',
      component: ScreenLoadingPage,
      beforeEnter: guardRoute
    },
    {
      path: '/adminactivity',
      name: 'adminactivity',
      component: AdminActivityPage,
      beforeEnter: guardRoute
    },
    {
      path: '/lessonwiseprogress',
      name: 'lessonwiseprogress',
      component: LessonWiseProgress,
      beforeEnter: guardRoute
    },
    {
      path: '/elementwiseprogress',
      name: 'elementwiseprogress',
      component: ElementWiseProgress,
      beforeEnter: guardRoute
    },
    {
      path: '/resetpassword',
      name: 'resetpassword',
      component: ResetPassword,
      beforeEnter: guardRoute
    },
    {
      path: '/sendgrid',
      name: 'sendgrid',
      component: SendGridPage,
      beforeEnter: guardRoute
    },
    {
      path: '/ssoconfiguration',
      name: 'ssoconfiguration',
      component: SSOConfigurationPage,
      beforeEnter: guardRoute
    },
    {
      path: '/test',
      name: 'TestPage',
      component: TestPage,
      beforeEnter: guardRoute
    },
    {
      path: '/mentora365',
      name: 'mentora365',
      component: mentoraPage,
      beforeEnter: guardRoute
    },
    {
      path: '/msnotif',
      name: 'MSNotif',
      component: msNotificationPage,
      beforeEnter: guardRoute
    },
    {
      path: '/m365Report',
      name: 'm365Report',
      component: m365ReportPage,
      beforeEnter: guardRoute
    },
    {
      path: '/momentsreport',
      name: 'MomentsReport',
      component: MomentsReportPage,
      beforeEnter: guardRoute
    },
    {
      path: '/missionReport',
      name: 'missionReport',
      component: missionReportPage,
      beforeEnter: guardRoute
    },
    {
      path: '/adaptiveGameReport',
      name: 'adaptiveGameReport',
      component: adaptiveGameReportPage,
      beforeEnter: guardRoute
    },
    {
      path: '/descriptivevideoreport',
      name: 'VATConsumptionReport',
      component: vatConsumptionReportPage,
      beforeEnter: guardRoute
    },
    {
      path: '/milestonereport',
      name: 'MilestoneReport',
      component: milestoneReportPage,
      beforeEnter: guardRoute
    },
    {
      path: '/certificatereport',
      name: 'CertificateReport',
      component: certificateReportPage,
      beforeEnter: guardRoute
    },
    {
      path: '/lpreport',
      name: 'LearnPerformReport',
      component: learnPerformReportPage,
      beforeEnter: guardRoute
    },
    {
      path: '/tinymce',
      name: 'tinyMcePage',
      component: tinyMcePage,
      beforeEnter: guardRoute
    }
  ]
})
/*
function getRoutesInternal () {
  var currUser = JSON.parse(localStorage.getItem(constants.LOGIN_USER_COOKIE))
  console.log('CURR USER ' + JSON.stringify(currUser))
  var routeArr = []
  if (currUser === null || currUser === undefined) {
    routeArr = [
      {
        path: '/login',
        name: 'login',
        component: LoginPage
      },
      {
        path: '*',
        name: 'Error',
        component: ErrorPage,
        beforeEnter: guardRoute
      }
    ]
    return routeArr
  }
  switch (currUser.AccountType) {
    case constants.UserAccountType.Admin:
      routeArr = [
        {
          path: '/',
          name: 'home',
          component: DashboardPage,
          beforeEnter: guardRoute
        },
        {
          path: '/courses',
          name: 'courses',
          component: CoursePage,
          beforeEnter: guardRoute
        },
        {
          path: '/users',
          name: 'users',
          component: UserPage,
          beforeEnter: guardRoute
        },
        {
          path: '/groups',
          name: 'groups',
          component: GroupPage,
          beforeEnter: guardRoute
        },
        {
          path: '/cohorts',
          name: 'cohorts',
          component: cohortsPage,
          beforeEnter: guardRoute
        },
        {
          path: '/login',
          name: 'login',
          component: LoginPage
        },
        {
          path: '/challenges',
          name: 'Challenges',
          component: ChallengePage,
          beforeEnter: guardRoute
        },
        {
          path: '*',
          name: 'Error',
          component: ErrorPage,
          beforeEnter: guardRoute
        },
        {
          path: '/managecontent',
          name: 'ManageContent',
          component: ManageContentPage,
          beforeEnter: guardRoute
        },
        {
          path: '/userresponses',
          name: 'UserResponses',
          component: UserResponsesPage,
          beforeEnter: guardRoute
        },
        {
          path: '/challengereport',
          name: 'ChallengeReport',
          component: ChallengeReportPage,
          beforeEnter: guardRoute
        },
        {
          path: '/userprogress',
          name: 'UserProgress',
          component: UserProgressPage,
          beforeEnter: guardRoute
        },
        {
          path: '/mcqreport',
          name: 'MCQReport',
          component: MCQReportPage,
          beforeEnter: guardRoute
        },
        {
          path: '/deepdive',
          name: 'DeepDive',
          component: DeepDivePage,
          beforeEnter: guardRoute
        },
        {
          path: '/discussions',
          name: 'Discussions',
          component: DiscussionsPage,
          beforeEnter: guardRoute
        },
        {
          path: '/profile',
          name: 'Profile',
          component: ProfilePage,
          beforeEnter: guardRoute
        },
        {
          path: '/dashboard',
          name: 'Dashboard',
          component: DashboardPage,
          beforeEnter: guardRoute
        },
        {
          path: '/resetpassword',
          name: 'resetpassword',
          component: ResetPasswordPage,
          beforeEnter: guardRoute
        },
        {
          path: '/email',
          name: 'email',
          component: EmailPage,
          beforeEnter: guardRoute
        },
        {
          path: '/progressionemail',
          name: 'progressionemail',
          component: ProgressionEmailPage,
          beforeEnter: guardRoute
        },
        {
          path: '/viewsentemails',
          name: 'viewsentemails',
          component: ViewSentEmailPage,
          beforeEnter: guardRoute
        },
        {
          path: '/filerepository',
          name: 'fileuploader',
          component: FileUploaderPage,
          beforeEnter: guardRoute
        },
        {
          path: '/adminactivity',
          name: 'adminactivity',
          component: AdminActivityPage,
          beforeEnter: guardRoute
        }
      ]
      break
    case constants.UserAccountType.Group_Admin:
      routeArr = [
        {
          path: '/',
          name: 'home',
          component: DashboardPage,
          beforeEnter: guardRoute
        },
        {
          path: '/login',
          name: 'login',
          component: LoginPage
        },
        {
          path: '*',
          name: 'Error',
          component: ErrorPage,
          beforeEnter: guardRoute
        },
        {
          path: '/profile',
          name: 'Profile',
          component: ProfilePage,
          beforeEnter: guardRoute
        },
        {
          path: '/dashboard',
          name: 'Dashboard',
          component: DashboardPage,
          beforeEnter: guardRoute
        },
        {
          path: '/resetpassword',
          name: 'resetpassword',
          component: ResetPasswordPage,
          beforeEnter: guardRoute
        }
      ]
      break
    case constants.UserAccountType.User:
      routeArr = [
        {
          path: '/login',
          name: 'login',
          component: LoginPage
        }
      ]
      break
    case constants.UserAccountType.Coach:
      routeArr = [
        {
          path: '/login',
          name: 'login',
          component: LoginPage
        }
      ]
      break
    default:
      routeArr = [
        {
          path: '/login',
          name: 'login',
          component: LoginPage
        },
        {
          path: '*',
          name: 'Error',
          component: ErrorPage,
          beforeEnter: guardRoute
        }
      ]
      break
  }
  return routeArr
} */

function guardRoute (to, from, next) {
  if (window.location.hostname !== 'localhost' && window.location.protocol === 'http:') {
    // console.log(`redirect to https`)
    window.location = `https://${window.location.host}/#${to.fullPath}`
    return
  }
  // console.log(' TO : ' + to.path)
  // console.log(' FROM : ' + from.path)
  // console.log(' NEXT : ' + next)
  // console.log(' CONSTANTS : ' + constants.LOGIN_COOKIE_KEY)
  next()
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js